<template>

    <section> 
              <b-container>
                <b-row align-v="center" class="row-grid">
                  <b-col md="6" class="order-md-2">
                    <b-img src="img/custom/an_internal_revolution.png" fluid />
                  </b-col>
                  <b-col md="6" class="order-md-1">
                    <div class="pr-md-5">
                      <h1>Do you currently sell your art?</h1>
        
                            
        <div class="hint" v-if="currentSnapWizard.sell_art == 0">
            Dear Artist
                            <br>
                            <br>
    Thank you for considering us for a collaboration. We appreciate your creative efforts and the work you are doing. <br> <br>
    
    However, for a successful publication, we require a customer base that can preorder at least 25 books within a two-week period. <br>
    Once you have established a paying customer base, we would be delighted to explore collaboration opportunities with you. Please feel free to reach out to us at that time.
    <br> <br>
    Keep creating, and we hope to work together in the future! <br>                        
        </div>
        
        
        
                            <b-form-radio-group v-model="currentSnapWizard.sell_art">
                            <div>
                                <b-form-radio value="1" name="unchecked" class="mb-3">
                                    Yes, I do sell my art
                                </b-form-radio>
                            </div>
                            <div>
                                <b-form-radio value="0" name="checked" class="mb-3">
                                    Not yet
                                </b-form-radio>
                            </div>
                        </b-form-radio-group>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </section>
        
        
           
           
        
        </template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'

export default {
    name: 'snap04',
        components: {
            TagsInput,
            [Tooltip.name]: Tooltip
        },
        methods: {
            onCancel: function () { },
            onProceed: function () { },
            allDataValidated: function () {
                if (
                    this.currentSnapWizard.sell_art == 1
                ) {
                    //this.claim.allValidated = true;
                    console.log("VALID ENABLING NEXT");
                    this.$emit('allowProceed');
                    this.$emit('showFooterNav');
                    return true;
                }
                this.$emit('denyProceed');
                this.$emit('hideFooterNav');
                return false;
            },
        },
        computed: {
            ...mapGetters({
                currentSettings: 'currentSettings',
                currentSnapWizard: 'currentSnapWizard',
                currentSnapWizardStep: 'currentSnapWizardStep',
            }),
        },
        watch: {
            currentSnapWizard: {
                handler:function (newItem) {
                    //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                    //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                    this.allDataValidated();
                },
                deep: true
            },
        },
        mounted() {
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            this.allDataValidated();
        }
    };
    </script>